var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoolicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83334 4.66667C2.83334 2.36548 4.69882 0.5 7.00001 0.5C9.3012 0.5 11.1667 2.36548 11.1667 4.66667C11.1667 6.96785 9.3012 8.83333 7.00001 8.83333C4.69882 8.83333 2.83334 6.96785 2.83334 4.66667ZM7.00001 7.16667C8.38072 7.16667 9.50001 6.04738 9.50001 4.66667C9.50001 3.28595 8.38072 2.16667 7.00001 2.16667C5.6193 2.16667 4.50001 3.28595 4.50001 4.66667C4.50001 6.04738 5.6193 7.16667 7.00001 7.16667Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28596 11.6193C1.03572 12.8695 0.333344 14.5652 0.333344 16.3333H2.00001C2.00001 15.0073 2.52679 13.7355 3.46448 12.7978C4.40216 11.8601 5.67393 11.3333 7.00001 11.3333C8.32609 11.3333 9.59786 11.8601 10.5355 12.7978C11.4732 13.7355 12 15.0073 12 16.3333H13.6667C13.6667 14.5652 12.9643 12.8695 11.7141 11.6193C10.4638 10.369 8.76812 9.66667 7.00001 9.66667C5.2319 9.66667 3.53621 10.369 2.28596 11.6193Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolicon);
export default __webpack_public_path__ + "static/media/coolicon.6bc7992f70eac7168de0284219e153fb.svg";
export { ForwardRef as ReactComponent };